import React, {useEffect} from "react";
import {useAuth} from 'util/auth'
import { useDispatch, useSelector } from "react-redux";
import {loadReservations} from 'store/actions/userActions'
import moment from 'moment-timezone'
import Accordion from 'react-bootstrap/Accordion';
import Button from "react-bootstrap/Button";
import Card from 'react-bootstrap/Card';
import Image from 'react-bootstrap/Image';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import Dropdown from 'react-bootstrap/Dropdown'
import SweetAlert from 'react-bootstrap-sweetalert'
import {cancelUserReservation} from 'store/actions/userActions'
import Spinner from 'react-bootstrap/Spinner'
import ShareButton from 'components/ShareButton'

moment.locale('en', {
  calendar : {
      lastDay : '[Yesterday]',
      sameDay : '[Today at] LT',
      nextDay : '[Tomorrow at] LT',
      lastWeek : '[last] dddd [at] LT',
      nextWeek : 'dddd [at] LT',
      sameElse : 'MMM Do [at] LT'
  }
});

function ReservationCard({reservation, ...otherProps}) {

  const [loading, setLoading] = React.useState(false)
  const [alert, setAlert] = React.useState(null)
  const dispatch = useDispatch()

  function actuallyCancelRes() {
    setAlert(false)
    setLoading(true)
    dispatch(cancelUserReservation(reservation.id))
      .then(response => {
        console.log(response)
        setLoading(false)
        if (response?.message) {
          setAlert(<SweetAlert
            title=""
            onConfirm={() => setAlert(false)}
          >
            {response.message}
          </SweetAlert>)
        }
      })
  }

  function handleModify() {
    setAlert(
    <SweetAlert 
    title={`Modify class booking`}
    onConfirm={() => setAlert(false)}
    onCancel={() => setAlert(false)}
    >
      Email Sutra support! <a target="__blank" href="mailto:hello@sutra.fit">hello@sutra.fit</a>
    </SweetAlert>)
  }

  function handleCancel() {
    setAlert(
      <SweetAlert
      style={{marginTop: "100px"}}
      danger
      showCancel
      confirmBtnText="Yes"
      confirmBtnBsStyle="danger"
      title="Cancel Booking"
      onConfirm={() => actuallyCancelRes()}
      onCancel={() => setAlert(false)}
      focusCancelBtn
    >
      Are you sure you want to cancel?
    </SweetAlert>
    )
  }
  

  const {objectSnapshot, canceled} = reservation
  if (!objectSnapshot) {
    return null
  }
  
  const {
    start_time,
    name,
    class_name,
    description,
    class_about,
    instructor_name,
    duration,
    images,
    content_link,
    reserve_link
    // let accessLink = val.content_link ?? val.reserve_link ?? "unkown";
  } = objectSnapshot

  const start = moment(start_time * 1000)
  const end = moment(start_time * (duration * 60) * 1000)

  const viewModel = {
    name: name ?? class_name,
    description: description ?? class_about,
    instructor_name,
    datetime: start.calendar() + ` (${duration}min)` + ` ${moment.tz(moment.tz.guess()).format('z')}`,
    image: images.length > 0 ? images[0] : null,
    canceled: canceled,
    content_link: content_link ?? reserve_link
  }

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </a>
  ));
  return (
    <Card disabled={true} border='white' className='text-left p-0' style ={{width: '100%'}}>
      {alert}
      <Accordion>
      <Card.Body className='p-1'>
        <div className='d-flex flex-row align-items-center justify-content-between'>
          <div className='d-flex flex-row align-items-center'>
            <div style={{height: '80px', width: '80px'}} className="mr-3">
                <Image src={viewModel.image} roundedCircle style={{objectFit: 'cover', objectPosition: 'center', width: '100%', height: '100%'}} />
            </div>
            <div>
              <Card.Title className='mb-1'>
                {viewModel.name} 
                {viewModel.canceled && (
                  <span className="_danger">&nbsp;(Canceled)</span>
                )}
              </Card.Title>
              <Card.Text className="m-0 p-0">
                {viewModel.datetime}
              </Card.Text>
              
              <Card.Text className="m-0 p-0 font-weight-bold">
                  {viewModel.instructor_name}
              </Card.Text>
              <Accordion.Toggle as={Button} variant="link" eventKey="0" className='primaryColor m-0 p-0'>
                  View Details
              </Accordion.Toggle>
            </div>
            
          </div>
          {loading ? (
            <Spinner
            animation="border"
            size="sm"
            aria-hidden={true}
            className="ml-2"
            />
          ) : (
            <Dropdown>
              <Dropdown.Toggle  as={CustomToggle} id="dropdown-basic">
                <MoreHorizIcon className="primaryColor" />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {/* <Dropdown.Item className="primaryColor" onClick={() => {
                    handleModify()
                }}>Modify</Dropdown.Item> */}

                {!viewModel.canceled && (
                  <Dropdown.Item className="primaryColor" onClick={() => {
                      handleCancel()
                  }}>Cancel</Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>
          )}

        </div>
        <div>
            <Accordion.Collapse eventKey="0">
            <div>
              <Card.Text>
                {viewModel.description}
              </Card.Text>
              
              {!viewModel.canceled && viewModel.content_link && (
                <div className="d-flex d-row align-items-center">
                  <input
                  style={{paddingRight: "50px"}}
                  type="text" value={viewModel.content_link} readOnly={true} className={"form-control"}/>
                  <ShareButton link={viewModel.content_link} 
                  style={{marginLeft: "-50px"}}
                  />
                </div>
              )}
              </div>
            </Accordion.Collapse>
        </div>
      </Card.Body>
      
      </Accordion>

      <hr />
    </Card>
  )
}

// Users bookings with the ability to cancel
function BookingsSection() {

  const auth = useAuth()
  const dispatch = useDispatch()
  const reservations = useSelector(state => state.user.reservations)

  const upcomingReservations = reservations.filter(val => {
    return val.objectSnapshot?.start_time > moment().unix()
  }).sort((a,b) => {
    return a.objectSnapshot?.start_time - b.objectSnapshot?.start_time
  })

  useEffect(() => {
    if (auth.userData) {
      dispatch(loadReservations(auth.userData))
    }
    
  }, [dispatch, auth.userData])

  return (
  <>
  <section>
    <h3 className="font-weight-bold">Upcoming classes</h3>
    {upcomingReservations.map(element => {
      return <ReservationCard key={element.id} reservation={element} />
      // return (<li key={element.id}>{moment(element.objectSnapshot.start_time * 1000).format("LLL")}</li>)
    })}

  </section>
    
  </>
  );
}

export default BookingsSection;